"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appleAuthApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function appleAuthApiClient(networkClient) {
    return {
        createHostedAuth: async (body) => {
            return networkClient.postHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/api/v2/apple-auth/hosted/bearer`, body);
        },
        createTeamAuth: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/api/v2/apple-auth/teams/${params.teamId}/bearer`, body);
        },
        importAuth: async (body) => {
            return networkClient.postHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/api/v2/apple-auth/bearer/import`, body);
        },
        listTeamOrganisations: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/api/v2/apple-auth/teams/${params.teamId}/organisations`, query, config);
        },
        listTierCurrencies: async (params) => {
            return networkClient.listHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/api/v2/apple-auth/tiers/${params.id}/currencies`, {}, { all: true });
        },
        listConnections: async (query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/api/v2/apple-auth/connections`, query, config);
        },
        listOrganisations: async (query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/api/v2/apple-auth/organisations`, query, config);
        },
        countOrganisations: async (query) => {
            return networkClient.getHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/api/v2/apple-auth/organisations/count`, query);
        },
        updateOrganisation: async (params, body) => {
            return networkClient.putHttp(data_lib_1.APPLE_AUTH_WEB_SERVICE, `/api/v2/apple-auth/organisations/${params.parentOrgRef}/${params.orgRef}`, body);
        },
    };
}
exports.appleAuthApiClient = appleAuthApiClient;
